export const LOGOS = {
  emblem: "/gs-emblem.png",
  wordmark: "/gs-wordmark.png",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Bespoke Sourcing", to: "/bespoke-sourcing" },
  { label: "What We Source", to: "/#what-we-source" },
  { label: "How It Works", to: "/#how-it-works" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const CATEGORIES = [
  "Property & Real Estate",
  "Bespoke Sourcing",
  "Commercial",
  "Materials & Equipment",
];

export const MANDATE_STATUSES = [
  "New", "Reviewing", "Qualified", "Sourcing", "Opportunity Identified",
  "Introduced", "Negotiating", "Completed", "Closed",
];

export const ENQUIRY_STATUSES = [
  "New", "Contacted", "Qualified", "Proposal Sent", "Negotiating", "Converted", "Closed",
];

export const STAT_SOURCES = [
  { key: "manual", label: "Manual (type a value)" },
  { key: "opportunities_active", label: "Live Opportunities (auto)" },
  { key: "opportunities_total", label: "Total Opportunities (auto)" },
  { key: "markets", label: "Active Markets (auto)" },
  { key: "leads_total", label: "Total Leads · CRM (auto)" },
  { key: "enquiries_total", label: "Enquiries · CRM (auto)" },
  { key: "mandates_total", label: "Bespoke Mandates (auto)" },
  { key: "deals_completed", label: "Deals Completed (auto)" },
];

export const COUNTRIES = [
  "United Kingdom", "Ghana", "United States", "Canada", "Nigeria",
  "British Virgin Islands", "Qatar", "United Arab Emirates", "Saudi Arabia",
  "India", "Singapore", "Hong Kong", "Australia", "New Zealand", "France",
  "Germany", "Spain", "Portugal", "Italy", "Netherlands", "Switzerland",
  "Ireland", "Egypt", "Morocco", "Côte d'Ivoire", "Senegal", "Tanzania",
  "Uganda", "Rwanda", "Zambia", "Zimbabwe", "Other",
];

export const DISCLAIMER =
  "Goldstone Sourcing provides sourcing and introduction services. Information presented is for general commercial purposes and does not constitute financial, legal, tax or investment advice. Independent professional advice should be obtained where appropriate.";
